module.exports = __webpack_public_path__ + "static/media/1.2e0768a0.png";